import PageName from "../../components/pagename";
import Image from "next/image";
import ButtonBorder from "../../components/assets/RoundedBorder";
import RelatedProjects from "../../components/products/RelatedProjects";
import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import Link from "next/link";

import ProjectsComp from "../../components/projects";

export default function ProductPage({ product, projectsData }) {
  const router = useRouter();
  const [lang, setLang] = useState(router.locale);
  useEffect(() => {
    setLang(router.locale);
  }, [router.locale]);

  const t = useTranslations("single_product");

  const newArr = projectsData
    .filter((item) => item._id !== product._id)
    .slice(0, 2);

  return (
    <>
      <PageName title={product?.[lang].iconTitle} img="career/Lightbulb" />
      <div className="xl:m-auto responsive  lg:mx-3 mx-3 md:mx-3 lg:max-w-[90rem] lg:my-5 lg:grid lg:grid-cols-12 flex flex-col-reverse">
        {/* paraghraph */}
        <div className="col-span-12 lg:col-span-5 my-5 ">
          <span className="hidden lg:block text-[32px] my-9 text-[#010140] font-[590] leading-[40px]">
            {t("about_product")}
          </span>

          <div className="lg:max-w-[572px] md:max-w-[40rem] lg:mx-0 mx-auto mb-[2rem]">
            <span className="text-[18px]  font-[400] leading-[26px] text-[#010140] mx-auto"></span>
            <div dangerouslySetInnerHTML={{ __html: product?.[lang]?.title }} />
          </div>
          <div className="relative cursor-pointer z-10 ">
            <button className=" rounded-[47px]  bg-gradient-to-r from-[#FE17FF] via-[#6232EA] to-[#2EBBFF] p-[2px] text-[#010140]">
              <Link href="/contact">
                <span className="block self-end rounded-full bg-white px-8 py-3 text-[16px] font-[510]">
                  {t("request_quote")}
                </span>
              </Link>
            </button>
          </div>
        </div>
        {/* image */}
        <div
          key={lang}
          className={`col-span-12 lg:col-span-6 my-9 w-full h-fit sm:pr-3 pt-3 
          ${lang === "ar" ? "lg:mr-auto" : "lg:ml-auto"}
           mx-auto lg:mx-0 max-w-[472px]`}
        >
          <div className="relative  min-w-[200px]">
            <div className="mx-auto max-w-full h-[200px] sm:h-[260px] mds:h-[329px]  w-[452px] relative  ">
              <Image
                src={product.innerImage || "/products/tau.png"}
                priority={true}
                alt={"career"}
                layout="fill"
                objectFit="cover"
                className="rounded-[10px]"
              />
            </div>

            <div className=" absolute h-[138px] sm:h-[183px] w-[138px] sm:w-[183px] z-[-10] top-[-9px] md:top-[-12px] right-[-9px] md:right-[-12px]">
              <Image
                src={"/career/border.png"}
                layout="fill"
                alt="ascot website careers"
              />
            </div>

            <div className=" absolute h-[55%] md:h-[183px] w-[183px] z-[-10] bottom-[-9px] md:bottom-[-12px] left-[-9px] md:left-[-12px]">
              <Image
                src={"/career/border.png"}
                layout="fill"
                alt="ascot website careers"
              />
            </div>
          </div>
        </div>
      </div>

      {/* related products  */}
      <div className=" h-fit mt-10  pb-32 -mb-20 bg-[#010140] bg-opacity-5 skew-y-3  ">
        <div className="transform max-w-[90rem] my-20 -skew-y-3 lg:px-32 h-32  mx-auto">
          <div className="w-full mx-auto flex py-14">
            <div className="mx-auto flex flex-col items-center">
              <span className="leading-[56px] text-[#010140] text-[48px] font-[590]">
                {t("related_projects")}
              </span>
              <div className="w-40 mt-1.5 h-[5px] bg-black mx-auto rounded-[22.5px] bg-gradient-to-r from-[#2EBBFF] via-[#FE17FF] to-[#6232EA]"></div>
            </div>
          </div>
        </div>

        <div className=" -skew-y-3 responsive max-w-[90rem] mx-auto">
          <div className="grid grid-cols-12  gap-5 mb-10">
            {newArr.map((product, i) => {
              return (
                <Link href={`/products/${product._id}`}>
                  <div
                    key={product._id}
                    className="cursor-pointer col-span-12 mds:col-span-6  bg-[#FFFFFF] border-[1px] border-[#951B8133] lg:h-48  min-w-[120px] h-[160px] items-center justify-center flex flex-col lg:gap-8 gap-6 rounded-[10px]"
                  >
                    <div className="lg:h-[65px] lg:w-[65px] w-[50px] h-[50px] relative">
                      <Image
                        src={product.icon}
                        layout="fill"
                        alt="single product"
                        className="object-cover"
                      />
                    </div>
                    {/* <div
                  dangerouslySetInnerHTML={{
                    __html: product?.icon,
                  }}
                ></div> */}
                    <span className="lg:text-[24px] text-[16px] text-center lg:leading-[24px] leading-[18px] lg:font-[274] font-[510]">
                      {product.iconTitle}
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps({ locale, query }) {
  try {
    const productId = query.id;
    const productsData = await axios.get(
      `${process.env.NEXT_APP_BACKEND_URL}user/products/one-Products/${productId}`,
      { data: { lang: "" } }
    );
    const projectsData = await axios.get(
      `${process.env.NEXT_APP_BACKEND_URL}user/products/all-products/${locale}`
    );

    const product = productsData?.data?.result;
    return {
      props: {
        product,
        projectsData: projectsData?.data?.result,
        messages: require(`../../locales/${locale || "en"}.json`),
      },
    };
  } catch (error) {
    return;
  }
}
